import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-space-between fill-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_LoginError = _resolveComponent("LoginError")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, {
      color: "transparent",
      height: "48"
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12",
              style: {"min-height":"68px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LoginError, { error: _ctx.error }, null, 8, ["error"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_sheet, { height: "48" }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      style: _normalizeStyle(!_ctx.error ? 'height: calc(100% - 68px - 68px)' : 'height: calc(100% - 68px)')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: _ctx.valid,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valid) = $event)),
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  autofocus: "",
                  placeholder: "Email address",
                  "persistent-placeholder": "",
                  variant: "underlined",
                  modelValue: _ctx.username,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                    _ctx.clearError
                  ],
                  rules: [v => !!v && v.length && v.includes('@') || 'Please enter a valid email address'],
                  autocomplete: "username",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.checkEmail(_ctx.username)), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          class: "d-flex justify-center mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              width: "95",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.checkEmail(_ctx.username)), ["prevent"])),
              color: "primary",
              disabled: !_ctx.username || !_ctx.valid || _ctx.loading,
              loading: _ctx.loading,
              class: "text-none"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Log in")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}